// ── NOTIFICATION BELL (fp-nofodesk-9 follow-up) — extracted from App.js ──
import { useState, useEffect } from "react";
import { Bell } from "lucide-react";
import { useT } from "../theme";
import { apiLoadTable, getToken } from "../utils/api";

function NotificationBell() {
  const T = useT();
  const [open, setOpen] = useState(false);

  const [nbActive, setNbActive] = useState([]);
  const [nbApps,   setNbApps]   = useState([]);
  useEffect(() => {
    if (!getToken()) return;
    Promise.all([apiLoadTable('active-grants'), apiLoadTable('pipeline-apps')]).then(([ag, apps]) => {
      if (ag)   setNbActive(ag);
      if (apps) setNbApps(apps);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const today = new Date(); today.setHours(0,0,0,0);
  const daysDiff = (dateStr) => {
    if (!dateStr) return null;
    const d = Math.ceil((new Date(dateStr) - today) / 86400000);
    return d >= 0 ? d : null;
  };

  const items = [];
  nbActive.forEach(g => {
    const d = daysDiff(g.end);
    if (d !== null && d <= 90)
      items.push({ id:`g-${g.id}`, name: g.shortTitle || g.title || "Grant", days: d, tag: "Grant End", color: d<=30?"#ef4444":d<=60?"#f97316":"#eab308" });
  });
  nbApps.forEach(a => {
    const d = daysDiff(a.deadline);
    if (d !== null && d <= 90)
      items.push({ id:`a-${a.id}`, name: a.title || a.funder || "Application", days: d, tag: "Deadline", color: d<=30?"#ef4444":d<=60?"#f97316":"#eab308" });
  });
  items.sort((a,b) => a.days - b.days);

  const d30 = items.filter(i => i.days <= 30);
  const d60 = items.filter(i => i.days > 30 && i.days <= 60);
  const d90 = items.filter(i => i.days > 60);

  const NRow = ({ item }) => (
    <div style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px", borderBottom:`1px solid ${T.borderDim}` }}>
      <span style={{ width:8, height:8, borderRadius:"50%", background:item.color, flexShrink:0 }} />
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontSize:12, color:T.textBody, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{item.name}</div>
        <div style={{ fontSize:10, color:T.textFaint }}>{item.tag}</div>
      </div>
      <span style={{ fontSize:11, fontWeight:600, color:item.color, whiteSpace:"nowrap" }}>{item.days}d</span>
    </div>
  );

  const SectionHead = ({ label }) => (
    <div style={{ padding:"6px 12px 4px", fontSize:10, fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:T.textFaint, background:T.bgHeader }}>{label}</div>
  );

  return (
    <div style={{ position:"relative" }}>
      <button onClick={() => setOpen(o=>!o)} aria-label="Notifications"
        style={{ position:"relative", padding:"6px 10px", background:T.bgElevated, border:`1px solid ${T.border}`, borderRadius:6, cursor:"pointer", lineHeight:1, color:T.textMuted, display:"flex", alignItems:"center" }}>
        <Bell size={16} />
        {items.length > 0 && (
          <span style={{ position:"absolute", top:-5, right:-5, minWidth:16, height:16, borderRadius:8, background:"#ef4444", color:"#fff", fontSize:9, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px" }}>
            {items.length}
          </span>
        )}
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position:"fixed", inset:0, zIndex:490 }} />
          <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, width:300, maxHeight:420, overflowY:"auto", background:T.bgSurface, border:`1px solid ${T.border}`, borderRadius:8, zIndex:491, boxShadow:"0 8px 24px rgba(0,0,0,0.3)" }}>
            <div style={{ padding:"10px 12px 8px", borderBottom:`1px solid ${T.border}`, fontSize:12, fontWeight:600, color:T.text }}>
              Upcoming Deadlines
            </div>
            {items.length === 0 ? (
              <div style={{ padding:"20px 16px", color:T.textFaint, fontSize:12, textAlign:"center" }}>No deadlines in the next 90 days</div>
            ) : (
              <>
                {d30.length > 0 && <><SectionHead label="🔴 Within 30 days" />{d30.map(i=><NRow key={i.id} item={i}/>)}</>}
                {d60.length > 0 && <><SectionHead label="🟠 31–60 days" />{d60.map(i=><NRow key={i.id} item={i}/>)}</>}
                {d90.length > 0 && <><SectionHead label="🟡 61–90 days" />{d90.map(i=><NRow key={i.id} item={i}/>)}</>}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
export default NotificationBell;
